import { Component, OnInit } from '@angular/core';
import { DutyPaymentsUgService } from 'src/app/services/payments/duty-payments-ug.service';
import { BankAccountsService } from 'src/app/services/bank-accounts/bank-accounts.service';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/services/shared/global.service';
import { PendingTasksHandler } from 'src/app/shared/pending-tasks-handler';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-upaid-duties-ug',
  templateUrl: './upaid-duties-ug.component.html',
  styleUrls: ['./upaid-duties-ug.component.css']
})
export class UpaidDutiesUgComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  unpaid_duties:any[] = [];
  searchText: string = '';
  bank_accounts:any[] = [];
  dutyPayment!: FormGroup;
  submitted: boolean = false;
  isProcessing: boolean = false;
  errorMessage: string | null = null;
  warningMessage: string | null = null;
  successMessage: string | null = null;
  selectedDuties: any[] = []; // Array to store selected duties
  amountToPay: number=0;
  public formatter: any;
  unpaidDuty: any;
  public consigneeId:string='';
  public entryAttachment:any={};
  orgId: any="";

    constructor(
      private dutyPaymentsUgService: DutyPaymentsUgService,
      private bankAccountsService: BankAccountsService,
      private formBuilder: FormBuilder,
      private globalService: GlobalService,
      private pendingTasksHandler: PendingTasksHandler,
      public auth: AuthService
    ){
      this.dutyPayment = this.formBuilder.group({
        payment_date: ['', Validators.required],
        bank_account: ['', Validators.required],
      });

      this.formatter = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

  ngOnInit(): void {
    this.isProcessing=true;
    this.orgId=localStorage.getItem('orgId');

    this.getBankAccounts(this.orgId)
    this.getUnpaidDuties();
    this.getUnpaidDutiesTotal();
  }

  /**
   * Get bank accounts
   */
  getBankAccounts(consigneeId:any)
  {
    this.bankAccountsService.filterBankAccountsByConsignee(consigneeId).subscribe((response: ApiResponse)=>this.bank_accounts=response.data);
  }

  /**
   * Get all unpaid duties
   */
  getUnpaidDuties()
  {
    this.dutyPaymentsUgService.getUnpaidDuties().subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.unpaid_duties = response.data;
          this.isProcessing=false;
          this.warningMessage=null;
          this.errorMessage=null;
        }else if(response.status==='no_data'){
            this.unpaid_duties=[];
            this.warningMessage=response.message;
            this.isProcessing=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isProcessing=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isProcessing=false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }

  // Function to handle checkbox change event
  checkboxChange(event: any, item: any,amount_to_pay:number) {
    if (event.target.checked) {
      // Add selected duty to the array
      this.selectedDuties.push({
        txn_id: item.txn_id,
        entry_id: item.entry_id,
        entry_no: item.entry_no,
        bl_no: item.bl_no,
        vehicle_id: item.vehicle_id,
        chassis_no: item.chassis_no,
        amount_paid: item.amount_paid,
        is_consolidated: item.is_consolidated
      });

      //Update amount to pay
      this.amountToPay=this.formatter.format(Number(this.amountToPay.toString().replaceAll(",",""))+Number(amount_to_pay));
    } else {
      // Remove unselected duty from the array
      this.selectedDuties = this.selectedDuties.filter(duty => duty.txn_id !== item.txn_id);

      //Update amount to pay
      this.amountToPay=this.formatter.format(Number(this.amountToPay.toString().replaceAll(",",""))-Number(amount_to_pay));
    }
  }

  isSelected(item: any): boolean {
    return this.selectedDuties.some(
      duty => duty.txn_id === item.txn_id
    );
  }

  getUnpaidDutiesTotal(): void {
    this.dutyPaymentsUgService.getUnpaidDutiesTotal().subscribe((response: ApiResponse) =>this.unpaidDuty = response.data);
  }

  handleSubmit():void {

    this.submitted=true;

    if(this.dutyPayment.valid) {
      if(this.selectedDuties.length===0){
        this.errorMessage="Please select duties to pay!";
      }else{
        this.isProcessing=true;

        this.dutyPaymentsUgService.addDutyPayment(this.dutyPayment.value,this.selectedDuties,this.amountToPay)
        .subscribe({
          next: (response) => {
            if(response.status==='success'){
              this.submitted = false;
              this.isProcessing=false;
              this.globalService.setGlobalSuccessMessage(response.message);

              this.getUnpaidDuties();
              this.getUnpaidDutiesTotal();

              //Reset selected duties array and total amount to pay
              this.selectedDuties = [];
              this.amountToPay=0;
              this.pendingTasksHandler.numberOfPendingUgDutyPayments(); //Count unpaid
            }else if(response.status==='error'){
              this.submitted = false;
              this.isProcessing=false;
              this.globalService.setGlobalErrorMessage(response.message);

                // Refresh upaid duties list
                this.getUnpaidDuties();
                this.getUnpaidDutiesTotal();
                //Reset selected duties array and total amount to pay
                this.selectedDuties = [];
                this.amountToPay=0;
            }else{
              this.submitted = false;
              this.isProcessing=false;
              this.globalService.setGlobalErrorMessage(response.message);

                // Refresh upaid duties list
                this.getUnpaidDuties();
                this.getUnpaidDutiesTotal();
                //Reset selected duties array and total amount to pay
                this.selectedDuties = [];
                this.amountToPay=0;
            }
          },
          error: (error) => {
            this.submitted = false;
            this.isProcessing=false;
            this.errorMessage=error;
          }
        });
      }
    }
  }

  viewEntryAndAssessmentNotice(entry_id:string){
    this.isProcessing=true;
    this.dutyPaymentsUgService.getEntryAndAssessmentNotice(entry_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.entryAttachment = response.data;
          this.isProcessing=false;
          this.warningMessage=null;
          this.errorMessage=null;
          window.open(this.entryAttachment.file_path, '_blank')?.focus();
        }else if(response.status==='no_data'){
            this.warningMessage=response.message;
            this.isProcessing=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please try again!";
          this.isProcessing=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isProcessing=false;
      }
    });
  }
}
